import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import Button from '../../../../components/Template/Button'

function TodayPicker({
  changeDate,
  className,
  size = 1,
}: ITodayPickerDispatch & ITodayPickerProps & WithTranslation) {
  return (
    <Button
      size={size}
      outline={true}
      style={{ marginLeft: `${1.5 * size}em` }}
      onClick={changeDate()}
      className={`${className}-button-today`}
    >
      <Trans i18nKey={'today'}>dzisiaj</Trans>
    </Button>
  )
}

export default TodayPicker

export interface ITodayPickerProps {
  className?: string
  size?: number
}

export interface ITodayPickerDispatch {
  changeDate: () => () => void
}
